import { deleteData, getData, postData, putData } from '../plugins/ApiCalls'

export function createTemplateBuild(data) {
  return postData('form-templates', data)
}

export function getFormTemplates() {
  return getData('form-templates')
}

export function updateFormTemplate(id, data) {
  return putData('form-templates/' + id, data)
}

export function getFormTemplateList(data) {
  return getData('form-templates/list?listParams=' + encodeURIComponent(JSON.stringify(data)))
}

export function getFormTemplate(id) {
  return getData('form-templates/' + id)
}

export function deleteFormTemplate(id) {
  return deleteData('form-templates/' + id)
}

export function getFormTemplateCategories(params = {}) {
  return Object.keys(params).length
    ? getData('form-template-categories', { params })
    : getData('form-template-categories')
}

export function getFormTemplateIndustries(params = {}) {
  return Object.keys(params).length
    ? getData('form-template-industries', { params })
    : getData('form-template-industries')
}

export function createFormTemplateTaxonomy(data, type) {
  return postData(`form-template-${type}`, data)
}

export function updateFormTemplateTaxonomy(id, data, type) {
  return putData(`form-template-${type}/${id}`, data)
}

export function deleteFormTemplateTaxonomy(id, type) {
  return deleteData(`form-template-${type}/${id}`)
}
